import styled from "styled-components";
import { workTypeDesignTokens as tokens } from "../../../work-type-shared/work-type-design-tokens";

export const ApplicationPanelSurface = styled.section`
  display: grid;
  min-width: 0;
  gap: ${tokens.spacing.md};
  padding: ${tokens.spacing.md};
  color: ${tokens.color.text};
  background: ${tokens.color.surface};
  border: 1px solid ${tokens.color.border};
  border-radius: ${tokens.radius.card};
`;

export const ApplicationPanelHeader = styled.header`
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 12px;
  align-items: start;
`;

export const ApplicationPanelIcon = styled.span`
  display: grid;
  width: 40px;
  height: 40px;
  place-items: center;
  color: ${tokens.tone.selected.text};
  background: ${tokens.tone.selected.background};
  border: 1px solid ${tokens.tone.selected.border};
  border-radius: ${tokens.radius.control};
  font-size: 20px;
`;

export const ApplicationPanelHeading = styled.div`
  display: grid;
  min-width: 0;
  gap: ${tokens.spacing.sm};

  h3,
  p {
    margin: 0;
  }

  h3 {
    font-size: 18px;
    line-height: 1.4;
  }

  p {
    color: ${tokens.color.textMuted};
    line-height: 1.5;
  }
`;
export const ApplicationPanelFacts = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${tokens.spacing.sm};
  align-items: center;
`;

export const ApplicationPanelChip = styled.span`
  display: inline-flex;
  min-height: 24px;
  align-items: center;
  padding: 2px 9px;
  color: ${tokens.tone.selected.text};
  background: ${tokens.tone.selected.background};
  border: 1px solid ${tokens.tone.selected.border};
  border-radius: ${tokens.radius.pill};
  font-size: 12px;
  font-weight: 700;
`;

export const ApplicationPanelFact = styled.span`
  color: ${tokens.color.textMuted};
  font-size: 13px;
`;

export const ApplicationPanelBody = styled.div`
  display: grid;
  min-width: 0;
  gap: 12px;
`;

export const SurfaceIntro = styled.div`
  display: grid;
  gap: 4px;

  h4,
  p {
    margin: 0;
  }

  h4 {
    font-size: 16px;
    line-height: 1.4;
  }

  p {
    color: ${tokens.color.textMuted};
    line-height: 1.5;
  }
`;

export const CountBadge = styled.span`
  display: inline-flex;
  width: fit-content;
  min-height: 24px;
  align-items: center;
  padding: 2px 9px;
  color: ${tokens.tone.approval.text};
  background: ${tokens.tone.approval.background};
  border: 1px solid ${tokens.tone.approval.border};
  border-radius: ${tokens.radius.pill};
  font-size: 12px;
  font-weight: 700;
`;

export const TimeSelectField = styled.label`
  display: grid;
  gap: 6px;
  color: ${tokens.color.text};
  font-weight: 700;

  select {
    width: 100%;
    min-height: ${tokens.control.height};
    padding: 0 12px;
    color: ${tokens.color.text};
    background: ${tokens.color.surface};
    border: 1px solid ${tokens.color.borderStrong};
    border-radius: ${tokens.radius.control};
  }

  select:focus-visible {
    outline: ${tokens.focus.outline};
    outline-offset: ${tokens.focus.offset};
  }
`;

export const TimeSummary = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: ${tokens.spacing.sm};

  > div {
    display: grid;
    gap: 4px;
    padding: 12px;
    background: ${tokens.color.surfaceMuted};
    border-radius: ${tokens.radius.control};
  }

  small {
    color: ${tokens.color.textMuted};
  }

  strong {
    font-size: 16px;
  }
`;

export const SurfaceState = styled.div`
  display: grid;
  gap: ${tokens.spacing.sm};
  padding: 12px;
  color: ${tokens.color.text};
  background: ${tokens.color.surfaceMuted};
  border: 1px solid ${tokens.color.border};
  border-radius: ${tokens.radius.control};

  button {
    width: fit-content;
    min-height: 40px;
  }
`;
